const fillServerErrors = require('../../olycommon/servererrorfiller'),
    { forOwn, forEach } = require('lodash');

class SignupController {
    constructor($scope, signupService, paypalService, analytics, settings, moveFocus) {
        this.$scope = $scope;
        this.signupService = signupService;
        this.paypalService = paypalService;
        this.analytics = analytics;
        this.settings = settings;
        this.moveFocus = moveFocus;

        this.signup = {
            TypeOfDeliveryMethod: 'Courier',
        };
        this.loading = false;
        this.isLoginWithPaypal = false;
        this.paypal = {};

        this.resetErrorMessages();

        // Settings
        this.signup.IdLikeToReceiveSmsTextsAboutProductsServicesAndPromotions = settings.registration.receiveSmsOfferByDefault;
        this.signup.IdLikeToReceiveEmailsAboutProductsAndServices = settings.registration.receiveEmailsByDefault;
        this.signup.IdLikeToBeSentTheCatalogue = settings.registration.receiveSampleByDefault;

        this.ShowSMSOffer = settings.registration.showSmsOffer;
        if (!this.ShowSMSOffer) {
            this.signup.IdLikeToReceiveSmsTextsAboutProductsServicesAndPromotions = false;
        }

        this.ShowReceiveSample = settings.registration.showReceiveSample;
        if (!this.ShowReceiveSample) {
            this.signup.IdLikeToBeSentTheCatalogue = false;
        }

        this.RewardsCardName = settings.everydayRewards.cardName;
    }

    $onInit() {
        this.analytics.pushEvent(this.analytics.events.SIGN_UP.START);
        this.showPayPalLoadingSpinner = true;
        this.setupPaypal().finally(() => {
            this.stopPaypalLoadingSpinner();
        });
    }

    setupPaypal() {
        return this.paypalService.setup({ enableShippingAddress: true }, response => this.paypalCallback(response));
    }

    stopPaypalLoadingSpinner() {
        this.showPayPalLoadingSpinner = false;
    }

    updateMobileFromPayPalResponse(phone) {
        const phoneNumber = phone.replace(/[-+/() ]/g, '');
        const auPrefix = /^61/g;
        if (auPrefix.test(phoneNumber)) {
            this.signup.MobilePhone = phoneNumber.replace(auPrefix, '0');
        }
    }

    resetErrorMessages() {
        this.errors = {
            generalError: false,
        };

        this.showErrors = false;
    }

    setErrorMessage(errorType, message) {
        this.errors[errorType] = message;
        this.showErrors = true;
        this.moveFocus('#errorMessage');
    }

    onEnter() {
    }

    getUserMessage() {
        return `The sign up was not successful.${this.signupValidationMessage
            ? ` ${this.signupValidationMessage}`
            : ''}`;
    }

    paypalLogin(event) {
        event.preventDefault();
        this.paypalService.initAuthFlow();
    }

    // Paypal
    paypalCallback(response) {
        const details = response.details;
        this.signup.firstName = details.firstName;
        this.signup.lastName = details.lastName;
        this.updateMobileFromPayPalResponse(details.phone);
        this.signup.EmailAddress = details.email;
        this.signup.PaypalEmail = details.email;
        this.signup.PaypalNonce = response.nonce;
        this.signup.PaypalDeviceData = this.paypalService.getDeviceData();
        this.isLoginWithPaypal = true;

        // Manual Address
        const address = this.paypalService.resolveAddress(details);
        this.addressFromPayPal = address;

        if (address !== null && address !== undefined) {
            this.initialAddress = {
                street1: (address.extendedAddress !== undefined)
                    ? [address.streetAddress.trim(), address.extendedAddress.trim()].join(' ')
                    : address.streetAddress.trim(),
                postcode: address.postalCode.trim(),
                suburbName: address.locality.trim(),
            };
            this.signup.TypeOfDeliveryMethod = 'Courier';
        }
        this.$scope.$apply();
    }

    cancelPaypalLogin(event) {
        event.preventDefault();
        this.isLoginWithPaypal = false;
        this.signup.PaypalNonce = null;
    }

    submitSignup() {
        fillServerErrors.clearForm(this.signupForm, this);
        this.resetErrorMessages();

        if (!this.signup.IsBusinessPurchase) {
            delete this.signup.companyName;
            delete this.signup.ABN;
            delete this.signup.TypeOfBusiness;
            delete this.signup.JobTitle;
            delete this.signup.EntityName;
        }
        // don't submit to server if client side is not valid. Set submitted anyway.
        if (!this.signupForm.$valid) {
            this.signupForm.$setSubmitted();
            return;
        }

        this.loading = true;
        this.signupService.signup(this.signup).then((res) => {
            this.loading = false;
            if (res.Success) {
                this.analytics.pushEvent(this.analytics.events.SIGN_UP.COMPLETED);
            } else if (!res.HasFieldErrors) {
                this.setErrorMessage('generalError', res.Message);
                this.analytics.pushEvent(this.analytics.events.SIGN_UP.FAILURE);
                this.analytics.pushError(res.Message);
            } else {
                this.signupValidationErrors = res.FieldErrors;
                this.signupValidationMessage = res.Message;
                this.analytics.pushEvent(this.analytics.events.SIGN_UP.FAILURE);
                this.analytics.pushErrors(this.createErrorListFromFieldErrors(res.FieldErrors));

                fillServerErrors.fillForm(this.signupForm, res.FieldErrors, this);
            }
        });
    }

    createErrorListFromFieldErrors(fieldErrors) {
        const errors = [];
        forOwn(fieldErrors, (fieldError) => {
            forEach(fieldError, (errorItem) => {
                errors.push(errorItem);
            });
        });
        return errors;
    }
}

SignupController.$inject = ['$scope', 'SignupService', 'PaypalService', 'AnalyticsService', 'Settings', 'MoveFocus'];

const signupControllerComponentDefinition = {
    controller: SignupController,
    template: require('./signup-form.component.html').trim(),
};

module.exports = {
    SignupController,
    signupControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/auth/signup/signup-form.component.js